import { render, staticRenderFns } from "./Loginv2.vue?vue&type=template&id=4ddd8b95&scoped=true"
import script from "./Loginv2.vue?vue&type=script&lang=js"
export * from "./Loginv2.vue?vue&type=script&lang=js"
import style0 from "./Loginv2.vue?vue&type=style&index=0&id=4ddd8b95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd8b95",
  null
  
)

export default component.exports